import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader } from "@/components/site/Blocks";
import { ContactForm } from "@/components/site/ContactForm";
import { OfficesSection } from "@/components/site/OfficesSection";
import { SITE } from "@/data/site";
import { buildHead } from "@/lib/seo-head";
import { PageEssentials } from "@/components/site/PageEssentials";

export const Route = createFileRoute("/es/contacto")({
  head: () =>
    buildHead({
      title: "Contacto — Oficial de Préstamos DSCR | Simply Approved Mortgages",
      description:
        "Contacte al escritorio DSCR de Simply Approved. Revisión inicial del escenario generalmente el mismo día hábil. Cotización formal y términos tras la suscripción.",
      url: "/es/contacto",
      locale: "es",
      keywords:
        "contacto préstamos DSCR, teléfono oficial préstamos DSCR, préstamos para propiedades de inversión, contacto corredor hipotecario inversionista, Florida préstamos DSCR contacto, Colorado préstamos DSCR contacto",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Contacto", url: "/es/contacto" },
      ],
      service: { name: "Originación de préstamos DSCR y con fines comerciales" },
    }),
  component: Contact,
});

function Contact() {
  return (
    <SiteShell>
      <PageHero eyebrow="Contacto" title="Hable con un oficial de préstamos." subtitle="Envíenos un mensaje o llame directamente al escritorio DSCR." />
      <PageEssentials />
      <Section>
        <div className="mx-auto max-w-3xl">
          <SectionHeader title="Contáctenos" intro={`Envíe su pregunta o escenario de préstamo a continuación, o llame al ${SITE.phone}. Un oficial de préstamos le responderá.`} />
          <div className="mt-6">
            <ContactForm locale="es" />
          </div>
        </div>
      </Section>
      <OfficesSection locale="es" />
    </SiteShell>
  );
}
